export const MirageApplicationTypes = {
    buildingcontrol: "buildingcontrol",
    landcharges: "landcharges",
    publicportal: "publicportal",
    planningmanagement: "planningmanagement",
    prePublicPortalWestLindsay: "prePublicPortalWestLindsay",
    streetnamingandnumbering: "streetnamingandnumbering",
} as const;

export const MirageInternalApplicationTypes = {
    buildingcontrol: MirageApplicationTypes.buildingcontrol,
    landcharges: MirageApplicationTypes.landcharges,
    planningmanagement: MirageApplicationTypes.planningmanagement,
    streetnamingandnumbering: MirageApplicationTypes.streetnamingandnumbering,
} as const;

export type IMirageApplications = typeof MirageApplicationTypes[keyof typeof MirageApplicationTypes];
export type MirageInternalApplication = typeof MirageInternalApplicationTypes[keyof typeof MirageInternalApplicationTypes];
